'use client'

import { MinusIcon } from 'lucide-react'
import { useEditorContext } from '@/components/ui/editor'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

const Divider = () => {
  const { editor, sourceMode } = useEditorContext()

  const insertDivider = () => {
    editor.chain().focus().setHorizontalRule().run()
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          size="sm"
          variant="ghost"
          title="Divider"
          onClick={insertDivider}
          disabled={sourceMode}
          tabIndex={-1}>
          <MinusIcon />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>Insert Divider</p>
      </TooltipContent>
    </Tooltip>
  )
}

export default Divider
